export const ZAPIER_UNLIMITED = 'unlimited';
export type ZAPIER_UNLIMITED = typeof ZAPIER_UNLIMITED;
export type PlanPermission = {
  // default value is false
  ga4: boolean;
  // default value is false
  iOS: boolean;
  // default value is false
  android: boolean;
  // default value is false
  PWA: boolean;
  // default value is false
  pushNotifications: boolean;
  // default value is false
  customDomain: boolean;
  // default value is false
  admob: boolean;
  // default value is 0
  numberOfMembers: number;
  // default value is 0
  numberOfRecords: number;
  // default value is 0
  zapier: number | ZAPIER_UNLIMITED;
  // default value is 0
  capacity: number;
  // default value is false
  vimeo: boolean;

  googleAnalytics: boolean; // Googleアナリティクス
  googleAuth2FA: boolean;
  numberOfApps: number; // アプリ数
  clickApi?: boolean;
  gptConversation?: boolean;
  videoElement?: boolean;
  timerElement?: boolean;
  chatElement?: boolean;
  updateMultipleObjectAction?: boolean;
  bookingCalendarElement?: boolean;
  focusInputAction?: boolean;
  workspaceFireWall?: boolean;
  /**
   * use affiliate
   */
  affiliateFeature?: boolean;
  csvUploadLimitationRecords?: number;
  findOneRecordAction?: boolean;
  /**
   * external api limitation
   */
  externalApiLimitation?: {
    /**
     * maximum number of request per [duration] seconds
     */
    limit: number;
    /**
     * unit: seconds
     */
    duration: number;
  };
  /**
   * maximum file upload size
   *
   * -1 means unlimited
   *
   * default: 5120000 ~ 5MB
   */
  fileUploadMaxSize?: number;
  /**
   * maximum image upload size
   *
   * -1 means unlimited
   *
   * default: 5120000 ~ 5MB
   */
  imageUploadMaxSize?: number
  /**
   * maximum video upload size
   *
   * -1 means unlimited
   *
   * default: 5120000 ~ 5MB
   */
  videoUploadMaxSize?: number
}

export interface ListPlan {
  /** The ListPlan id. */
  id?: number;
  /** Check status active */
  active: boolean;
  /** The array specific user or all user. */
  users?: {
    type: 'all' | 'list';
    /** The list user id
     * if type = 'all', array list will be empty
     * if type = 'list' array list will be specific user id
     */
    list: number[];
  };
  /** Config plan permission information */
  permission: PlanPermission;
  /** The planId
   * - maxLength: 50
   */
  planId: string;
  /** The planId
   * - maxLength: 100
   */
  stripeProductId?: string;
  /** The name
   * - maxLength: 100
   */
  name: string;
  /** The description
   * - maxLength: 1000
   */
  description: string;

  /** The amount of month*/
  amountMonth?: number;
  /** The amount of year*/
  amountYear?: number;
  /** Check status isDefault*/
  isDefault?: boolean;
  /** The total subscription*/
  totalSubscription?: number;

  isRecommended?: boolean;
}
